import React, { useState } from "react";
import WarningModal from "./WarningModal";

export default function OpenWarningModal({ children, action }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {React.cloneElement(children, { onClick: handleOpen })}
      {isOpen && (
        <WarningModal
          action={() => {
            action();
            handleOpen();
          }}
          handleOpen={handleOpen}
        />
      )}
    </>
  );
}
